import { call, put, takeEvery } from 'redux-saga/effects';
import { authActionCreators } from '..';
import { authService } from '../../..';

function* logout(action: ReturnType<typeof authActionCreators.logout>) {
  yield put(authActionCreators.setLoggedOut());

  if (action.payload.complete) {
    yield call(() => authService.logout());
  }
}

export function* watchLogout() {
  yield takeEvery(authActionCreators.logout.match, logout);
}
